module.exports = __webpack_public_path__ + "static/img/building.e546e7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hotel/building.jpg
// module id = s24+
// module chunks = 0